module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"รายการ Drone รอปรับแก้","page.description":"แสดงรายการ Drone รอการปรับแก้ ที่รอการยืนยันจากทาง HGR","drone.lot.chart.name":"Lot","drone.customer.chart.name":"เจ้าของเครื่อง","drone.model.chart.name":"Drone","drone.firmware.chart.name":"Firmware","drone.status.chart.name":"สถานะเครื่อง"}}')
  delete Component.options._Ctor
}
